import { render, staticRenderFns } from "./experimentCard.vue?vue&type=template&id=c778226e&scoped=true&"
import script from "./experimentCard.vue?vue&type=script&lang=js&"
export * from "./experimentCard.vue?vue&type=script&lang=js&"
import style0 from "./experimentCard.vue?vue&type=style&index=0&id=c778226e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c778226e",
  null
  
)

export default component.exports